<div class="card__container">
  <div class="card__experiencia__resgatada">
    <div class="header__area">
      <div class="experiencia__detalhes">
        <div class="experiencia__header">
          <div class="experiencia__header__itens">
            <p class="status__resgate">
              <img
                class="icon__status"
                alt="Ícone do status"
                src="assets/images/icons/observacao.png"
              />Promoção Meus Momentos
            </p>

            <div>
              <p class="experiencia__nome">
                {{ nomePromocao }}
              </p>
            </div>
          </div>
        </div>

        <div class="experiencia__footer">
          <div class="experiencia__valor__unidades"></div>
          <div class="validades">
            <div class="promocao__com__validade">
              <div class="resgate">
                <p class="resgate__tittle">Resgate</p>
                <p class="resgate__data">
                  {{ dataResgatePromocao }}
                </p>
              </div>
              <div class="vencimento">
                <p class="vencimento__tittle">Vencimento</p>
                <p class="vencimento__data">
                  {{ dataValidadeResgatePromocao }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ticket__codigo"></div>
</div>
